import React, {useEffect} from 'react'

import RoundedBtn from '../../components/RoundedBtn/RoundedBtn'
import MainLogo from '../../components/MainLogo/MainLogo'
import PageTitle from '../../components/PageTitle/PageTitle'
import {isIOS} from '../../util'

import iosStore from './ios.svg'
import playStore from './android.svg'
import './style.css'

const platform = isIOS ? 'ios' : 'android'

const MobileLink = ({link}) => {
    useEffect(() => {
        window.location = link
    }, [])

    return (
        <div className="get-mobile">
            <MainLogo absolute style={{marginTop: 60}} />

            <PageTitle standaloneMinor>Tap to go to Names &amp; Faces</PageTitle>

            <div className="get-mobile-button-container">
                <RoundedBtn type="a" href={link} tall>
                    Open Names &amp; Faces
                </RoundedBtn>
            </div>

            <p className="download-prompt">
                Download the app if you need.
                {isIOS && (
                    <span>
                        &nbsp;If tapping &lsquo;Open Names &amp; Faces&rsquo; doesn&lsquo;t work, open this link in
                        Safari.
                    </span>
                )}
            </p>

            <p className="store-links">
                {platform === 'ios' && (
                    <a href="https://itunes.apple.com/za/app/names-faces/id949875464">
                        <img src={iosStore} alt="Names & Faces on the App Store" height="52" width="154" />
                    </a>
                )}
                {platform === 'android' && (
                    <a href="https://play.google.com/store/apps/details?id=za.co.polymorph.namesfaces">
                        <img src={playStore} alt="Names & Faces on the Play Store" height="52" width="176" />
                    </a>
                )}
            </p>
        </div>
    )
}

export default MobileLink
